import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import QuestionContainer from '../components/QuestionContainer';
import Score from '../components/Score';

import * as actionCreators from '../actions/CombinedActions';

const mapStateToProps = state => (
  {
    correct: state.StateNames.correct,
    incorrect: state.StateNames.incorrect,
    current: state.StateNames.current,
    qtype: state.StateNames.qtype,
    refresh: state.StateNames.refresh,
  }
);

const mapDispatchToProps = dispatch => (
  { actions: bindActionCreators(actionCreators, dispatch) }
);

const DataContainer = ({ qtype, current, incorrect, correct, actions }) => (
  <div className="data__container">
    <Score
      count={correct}
      scoretype={'correct'}
    />
    <Score
      count={incorrect}
      scoretype={'incorrect'}
    />
    <QuestionContainer
      current={current}
      qtype={qtype}
      refresh={actions.refresh}
    />
  </div>
);

DataContainer.propTypes = {
  correct: PropTypes.number.isRequired,
  incorrect: PropTypes.number.isRequired,
  current: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    capital: PropTypes.string.isRequired,
    misses: PropTypes.number,
  }).isRequired,
  qtype: PropTypes.string.isRequired,
  actions: PropTypes.objectOf(PropTypes.func.isRequired).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataContainer);



// WEBPACK FOOTER //
// ./src/containers/DataContainer.js